// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"style__tooltip__nGitS"};